/** iter 42 — Mobile / Jobs list (assigned to me). */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import MobileShell from "../MobileShell";

export default function MJobs() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/mobile/my-jobs")
      .then(r => setItems(r.data || []))
      .catch(e => setErr(e?.response?.data?.detail || e.message));
  }, []);

  return (
    <MobileShell title="My Jobs">
      {err && <div className="m-empty" data-testid="m-jobs-error">{String(err)}</div>}
      {!err && items === null && <div className="m-empty">Loading…</div>}
      {!err && items?.length === 0 && (
        <div className="m-empty" data-testid="m-jobs-empty">
          No jobs assigned. New work will show up here.
        </div>
      )}
      {items?.map(j => (
        <button
          key={j.id}
          type="button"
          className="m-card"
          style={{ width: "100%", textAlign: "left", cursor: "pointer" }}
          onClick={() => navigate(`/m/jobs/${j.id}`)}
          data-testid={`m-job-row-${j.id}`}
        >
          <div className="m-card-title">
            #{j.job_number || "—"}{j.customer_name ? ` · ${j.customer_name}` : ""}
          </div>
          <div className="m-card-sub">
            {j.service_location_name || j.service_location_address1 || "No address on file"}
            {j.service_location_city ? ` · ${j.service_location_city}` : ""}
          </div>
          <div style={{ marginTop: 6 }}>
            {j.job_type_name && <span className="m-chip">{j.job_type_name}</span>}
            {j.job_status_name && <span className="m-chip">{j.job_status_name}</span>}
            {j.service_speed && <span className="m-chip">{j.service_speed}</span>}
          </div>
        </button>
      ))}
    </MobileShell>
  );
}
